var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var cio_config = require('cio-config');
if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");
var editor_2d = require("editor-2d");

var HoleInteractionModel = function (data, editorModel) {
    var self = this;
    editor_2d.AbstractPosInteractionModel.call(this, data, editorModel);
    this.boundingBox = this.data.boundingBox;

    var shape;
    if(self.data.description)
        shape = this.shadow("shapeShadow",
            function() {
                return self.data.description().shape();
            }, null,
            [self.data.description]
        );
    else
        shape = self.data.shape;

    this.showDiameter = this.shadow("showDiameter",
        function () {
            return shape().width() / self.origin.getGridFactor();
        },
        function (value) {
            return shape().width((value || 0) * self.origin.getGridFactor()) && shape().height((value || 0) * self.origin.getGridFactor());
        },
        [[shape, shape.onBubble],
         [this.origin, this.origin.onBubble]]
    );
    this.isCircular = this.shadow("isCircular",
        function () {
            return shape() instanceof cio_datamodel.EllipseData && shape().width() === shape().height();
        }, null,
        [[shape, shape.onBubble]]
    );
};
lib_core.inherit(HoleInteractionModel, editor_2d.AbstractPosInteractionModel);
HoleInteractionModel.$class = "HoleInteractionModel";

module.exports = HoleInteractionModel;

HoleInteractionModel.prototype.getSnapSet = function () {
    var snapSet = new editor_2d.SnapSet();

    snapSet.add(this.data.pos(), 1);

    return snapSet;
};

HoleInteractionModel.prototype.getInspectorElements = function () {
    var inspectorElements = editor_2d.AbstractPosInteractionModel.prototype.getInspectorElements.call(this);

    var gridUnit = this.origin.getGridUnitString();

    inspectorElements.input_elements.push(
        {
            label      : 'Diameter',
            type       : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember : this.showDiameter,
            datatype   : cio_config.types.positive_float,
            unit       : gridUnit,
            visible    : this.isCircular
        }
    );

    inspectorElements.help_elements = {
        'name': 'Hole'
    };

    return inspectorElements;
};
